<template>
  <div class="results-details ">
    <v-sheet
      v-if="$vuetify.breakpoint.lgAndUp"
      color="light"
      tile
    >
      <v-row
        no-gutters
      >
        <v-col>
          <v-sheet
            color="white"
            :elevation="2"
            tile
            class="fill-height"
            style="min-height:100vh;"
          >
            <v-container
              fluid
              class="px-6"
            >
              <v-btn
                rounded
                depressed
                color="white"
                small
                class="mb-2"
                @click="onCloseDrawer"
              >
                <v-icon
                  color="primary"
                  class="mr-1"
                >
                  mdi-close-circle
                </v-icon>
                <span class="primary--text text-decoration-underline">Close</span>
              </v-btn>
              <slot name="overview" />
            </v-container>
          </v-sheet>
        </v-col>
        <v-col>
          <v-container
            fluid
            class="px-6 pb-16"
          >
            <slot name="breakdown" />
          </v-container>
        </v-col>
      </v-row>
    </v-sheet>

    <template v-else>
      <div
        class="pb-3"
        style="position: sticky; z-index: 100; top:0;"
      >
        <v-sheet
          color="primary"
          tile
        >
          <div class="py-3 px-6">
            <v-btn
              rounded
              depressed
              color="white"
              small
              @click="onCloseDrawer"
            >
              <v-icon
                color="primary"
                class="mr-1"
              >
                mdi-close-circle
              </v-icon>
              <span class="primary--text text-decoration-underline">Close</span>
            </v-btn>
          </div>
        </v-sheet>

        <v-tabs
          v-model="tab"
          background-color="primary"
          dark
          centered
          class="elevation-4"
        >
          <v-tab>
            Policy Overview
          </v-tab>
          <v-tab>
            Cover Details
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container
            fluid
            class="px-6"
          >
            <slot name="overview" />
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container
            fluid
            class="px-6"
          >
            <slot name="breakdown" />
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
export default {
  name: 'results-details-layout',
  data: () => ({
    tab: null,
  }),
  methods: {
    onCloseDrawer () {
      this.$emit('close-drawer');
    },
  },
};
</script>
